<template>
  <v-sheet>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-sheet>
</template>

<script>
export default {
  name: 'EmptyLayout',
}
</script>
